/**
 * Energy Losses Table Component
 * Binary comparison table using only ✅ and ❌ symbols
 * No percentages. No kWh. No costs.
 */

interface EnergyLossesTableProps {
  printMode?: boolean;
}

export function EnergyLossesTable({ printMode = false }: EnergyLossesTableProps) {
  return (
    <div className="dp-energy-losses-table-container">
      <table className="dp-energy-losses-table">
        <thead>
          <tr>
            <th>Loss mechanism</th>
            <th>Older boiler system</th>
            <th>Modern system</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Complete fuel burn</td>
            <td className="dp-cell-negative">❌</td>
            <td className="dp-cell-positive">✅</td>
          </tr>
          <tr>
            <td>Low operating temperature</td>
            <td className="dp-cell-negative">❌</td>
            <td className="dp-cell-positive">✅</td>
          </tr>
          <tr>
            <td>Stable, continuous operation</td>
            <td className="dp-cell-negative">❌</td>
            <td className="dp-cell-positive">✅</td>
          </tr>
          <tr>
            <td>Minimal heat lost up the flue</td>
            <td className="dp-cell-negative">❌</td>
            <td className="dp-cell-positive">✅</td>
          </tr>
          <tr className="dp-row-summary">
            <td><strong>Overall efficiency outcome</strong></td>
            <td className="dp-cell-negative">❌❌❌❌</td>
            <td className="dp-cell-positive">✅✅✅✅</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
